var _excluded = ["id", "depth", "top", "measureElement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable import/prefer-default-export */
import React, { useCallback, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TreeItem } from "./TreeItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
var animateLayoutChanges = _ref => {
  var isSorting = _ref.isSorting,
    wasDragging = _ref.wasDragging;
  return !(isSorting || wasDragging);
};
export function SortableTreeItem(_ref2) {
  var id = _ref2.id,
    depth = _ref2.depth,
    top = _ref2.top,
    measureElement = _ref2.measureElement,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useSortable = useSortable({
      id,
      animateLayoutChanges
    }),
    attributes = _useSortable.attributes,
    isDragging = _useSortable.isDragging,
    isSorting = _useSortable.isSorting,
    listeners = _useSortable.listeners,
    setDraggableNodeRef = _useSortable.setDraggableNodeRef,
    setDroppableNodeRef = _useSortable.setDroppableNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var transformString = CSS.Translate.toString(transform);
  var style = useMemo(() => ({
    transform: transformString,
    transition
  }), [transformString, transition]);
  var handleProps = useMemo(() => _objectSpread(_objectSpread(_objectSpread({}, attributes), listeners), {}, {
    style
  }), [attributes, listeners, style]);
  var wrapperRef = useCallback(node => {
    setDroppableNodeRef(node);
    measureElement === null || measureElement === void 0 || measureElement(node);
  }, [setDroppableNodeRef, measureElement]);
  return /*#__PURE__*/_jsx(TreeItem, _objectSpread({
    dragRef: setDraggableNodeRef,
    wrapperRef: wrapperRef,
    depth: depth,
    ghost: isDragging,
    disableInteraction: isSorting,
    handleProps: handleProps,
    style: style,
    top: top
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props));
}
//# sourceMappingURL=SortableTreeItem.js.map